export const SystemPrototype = [
  {
    key: 1,
    Number: "Q1",
    question: "Is the system design complete?",
    value: 5,
  },
  {
    key: 2,
    Number: "Q2",
    question: "Does the system perform all the functional requirements",
    value: 5,
  },
  {
    key: 3,
    Number: "Q3",
    question: "Is the system robust?",
    value: 5,
  },
  {
    key: 4,
    Number: "Q4",
    question:
      "Is the system precise in its shape, size and/or material quality?",
    value: 5,
  },
  {
    key: 5,
    Number: "Q5",
    question:
      "Is the system a good representation of an actual design not only in appearance but also in the way the product works?",
    value: 5,
  },
];

export const SDG = [
  {
    Number: "Q6",
    question:
      "Does the proposed system tackle any of the Sustainable Development Goals?",
    value: 15,
  },
  {
    Number: "Q7",
    question: "Is the solution provided practical and scalable?",
    value: 10,
  },
];

export const Presentation = [
  {
    Number: "Q8",
    question: "Does the team Clearly introduce the problem they are tackling?",
    value: 5,
  },
  {
    Number: "Q9",
    question:
      "Do they state the objectives and functional requirements of their project?",
    value: 10,
  },
  {
    Number: "Q10",
    question:
      "Are they able to clearly describe the methodology to achieve their proposed solution?",
    value: 10,
  },
];

export const teamQualities = [
  {
    Number: "Q11",
    question: "Does the team have clear assigned roles?",
    value: 5,
  },
  {
    Number: "Q12",
    question: "Did the team show collaboration and togetherness?",
    value: 5,
  },
  {
    Number: "Q13",
    question:
      "Did the team show open communication during the developmental stages of their project?",
    value: 5,
  },
  {
    Number: "Q14",
    question:
      "How well did the team accept feedback and improve upon their work during the development of the project.",
    value: 10,
  },
];
